// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__lWv6j","line":"style_line__nVk34","title":"style_title__jWZ_L"};